import { Route, Routes } from 'react-router-dom';

import PageNotFound from '@components/error/404/PageNotFound';
import AuthLayout from '@shared/layout/auth/AuthLayout';

import LoginPage from './login/LoginPage';
import RegisterPage from './register/RegisterPage';
import RegisterPageContent from './register/components/RegisterPageContent';

const AuthRouter = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route index path="login" element={<LoginPage />} />
      <Route path="register/:type" element={<RegisterPageContent />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  </Routes>
);

export default AuthRouter;
